import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuthResetParams, AuthTokenResponse, IndustryItem, LinkedBusinessAccount, Employee } from '@shared/models';

export const AuthActions = createActionGroup({
  source: 'Auth Actions',
  events: {
    Initialize: emptyProps,
    'Auth Login': props<{ email: string; password: string }>(),
    'Auth Login Success': props<{ user: Employee | null; businessAccount: LinkedBusinessAccount | null }>(),
    'Auth Login Failure': props<{ error: string }>(),
    'Password Expired': props<{ providerToken: string; email?: string }>(),
    'Login Redirect': emptyProps,
    'Reset Login Error': emptyProps,
    'Auth Logout': props<{ params?: AuthResetParams }>(),
    'Auth Logout Completed': props<{ params?: AuthResetParams }>(),
    'Refresh Token': emptyProps,
    'Refresh Token Success': props<{ tokenInfo: AuthTokenResponse }>(),
    'Rehydrate Session': emptyProps,
    'No Active Session': emptyProps,
    'Load Industries Success': props<{ industries: IndustryItem[] }>(),
    'Load Industries Failure': props<{ error: string }>(),
  },
});
